import type { WorkloadDependencies } from '../../types/dependency-graph'

import { apiClient } from '../api/apiClient'
import { logger } from '../../utils/logger'

export const dependencyGraphService = {
  async getWorkloadDependencies(
    workload: string,
    environment: 'staging' | 'production' = 'production'
  ): Promise<WorkloadDependencies> {
    try {
      logger.log('Fetching dependencies for workload:', workload, 'environment:', environment)

      const params = new URLSearchParams({
        workload,
        environment
      })

      const response = await apiClient.get<WorkloadDependencies>(
        `/dependency-graph/fetch?${params.toString()}`
      )

      logger.log('Workload dependencies API response:', response)

      return response
    } catch (error) {
      logger.error('Failed to fetch workload dependencies:', error)
      throw new Error('Failed to fetch workload dependencies. Please try again later.')
    }
  }
}
